import './index.css';

export default {
  name: 'ArouterView',
  props: {
    name: { type: String, default: () => 'transition' }, // 可选 el-zoom-in-top
    mode: { type: String, default: () => '' }, // 可选 out-in
    appear: { type: Boolean, default: () => false },
    transition: { type: Boolean, default: () => false },
    cache: { type: Boolean, default: () => false },
  },
  render() {
    const { include = null, exclude = null, max = 1000 } = this.$props;
    return (
      <div class="a-router-view">
        {this.transition ? (
          <transition name={this.name} mode={this.mode} appear={this.appear}>
            {this.cache ? (
              <keep-alive include={include} exclude={exclude} max={max}>
                <router-view />
              </keep-alive>
            ) : (<router-view />)}
          </transition>
        ) : (
            <div>
              {this.cache ? (
                <keep-alive include={include} exclude={exclude} max={max}>
                  <router-view />
                </keep-alive>
              ) : (<router-view />)}
            </div>
          )
        }
      </div>
    );
  }
}